import classNames from 'classnames/bind';
import styles from '@/styles/superstack/base/SideBarIndex.module.scss';
import { asciiAlphaUpper } from '@/src/utils/consts';

const SideBarIndexScroll = ({ indexScrollList, elementListRef }) => {
  const cx = classNames.bind(styles);
  const indexNameList = asciiAlphaUpper.map((x) => String.fromCharCode(x)).concat('-');
  return (
    <div className={cx(['sideBar'])}>
      {indexNameList.map((name, index) => (
        <div
          className={cx(['sideBarIndex'])}
          key={index}
          onClick={() => {
            elementListRef.current[indexScrollList[index]] != null
              ? elementListRef.current[indexScrollList[index]].scrollIntoView()
              : null;
          }}
        >
          {name}
        </div>
      ))}
    </div>
  );
};

export { SideBarIndexScroll };
